import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Apis } from 'app/Apis/Apis'
import { Box } from '@mui/system'
import CkEditor from 'app/components/CkEditor/CkEditor'
import AddPolicy from '../../../components/PrivacyPolicy/AddPolicy'
import EditPolicy from '../../../components/PrivacyPolicy/EditPolicy'
import { Container } from '../utils/Utils'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

const PrivacyPolicy = () => {
    const [editorData, setEditorData] = useState(null)
    const [privacyPolicyData, setPrivacyPolicyData] = useState('')
    const [showEditor, setShowEditor] = useState(false)
    const [showEditorWithData, setShowEditorWithData] = useState(false)
    const [showAddPolicy, setShowAddPolicy] = useState(false) // Control rendering of AddPolicy
    const [runUseEffect, setRunUseEffect] = useState(false)

    const config = {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
    }

    useEffect(() => {
        async function fetchPrivacyPolicy() {
            try {
                const res = await axios.get(`${Apis.getPrivacyPolicy}`, config)
                let policy = res.data.data?.policy
                setPrivacyPolicyData(policy)
                setEditorData(policy)
                if (!policy) {
                    setShowEditor(false)
                    setShowAddPolicy(true) // Show the AddPolicy component after data has been fetched
                }
            } catch (error) {
                console.log(error)
            }
        }
        fetchPrivacyPolicy()
    }, [runUseEffect])

    async function addPolicy() {
        await axios
            .post(`${Apis.addPrivacyPolicy}`, { policy: editorData }, config)
            .then((res) => {
                if (res.data) {
                    setRunUseEffect(!runUseEffect)
                    setShowEditorWithData(false)
                    setShowEditor(false)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }
    const goBack = () => {
        setRunUseEffect(!runUseEffect)
                    setShowEditorWithData(false)
                    setShowEditor(false)
    }
    return (
        <Container>
            <Box
                sx={{
                    fontWeight: 600,
                    width: '100%',
                    justifyContent: 'space-between',
                }}
            >
                Privacy policy
            </Box>

            {privacyPolicyData && !showEditorWithData && (
                <EditPolicy
                    buttonText={'Edit policy'}
                    setShowEditorWithData={setShowEditorWithData}
                />
            )}
            <Box py="12px" />
            {privacyPolicyData && !showEditorWithData && (
                <div
                    dangerouslySetInnerHTML={{ __html: privacyPolicyData }}
                ></div>
            )}
            {!showEditor && showAddPolicy && (
                <AddPolicy
                    buttonText={'Add privacy policy'}
                    setShowEditor={setShowEditor}
                    setShowAddButton={setShowAddPolicy}
                />
            )}
            {showEditor && !showAddPolicy && (
                <>
                 <Box sx={{ padding: '15px 0px' }}>
                 <ArrowBackIcon style={{cursor:"pointer"}} onClick={() => goBack()}/>
                </Box>
                <CkEditor
                    setEditorData={setEditorData}
                    addFunction={addPolicy}
                    />
                    </>
            )}

            {showEditorWithData && privacyPolicyData && (
                <>
                 <Box sx={{ padding: '15px 0px' }}>
                 <ArrowBackIcon style={{cursor:"pointer"}} onClick={() => goBack()}/>
                </Box>
                <CkEditor
                    setEditorData={setEditorData}
                    addFunction={addPolicy}
                    initialData={privacyPolicyData}
                    />
                    </>
            )}
        </Container>
    )
}

export default PrivacyPolicy
